import React from 'react';
import classnames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from 'containers/atoms/LinkContainer';
import s from './RegionOfficesWithNames.css';

const RegionOfficesWithNames = ({ classes, ...other }) => {
  const classNames = classnames(s.regionOfficesWithNames, classes);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 790 564" className={classNames} {...other}>
      <g>
        <g className={s.county}>
          <Link to="/regioner/norrbotten/">
            <text transform="translate(644.5 95.713)">Norrbottens län</text>
          </Link>
          <Link to="/regioner/norrbotten/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M409 144.113l-1.8-.5-4.8-1.5-2.3-.9-15.1-15.3-3.3-.1-12.6-9.9-5.9-2.3-1.3-5.3 4.1-4.6 5.9-11.5 1.7-2.1 4.3-3.8.8-6.1-.6-2.6-4.4-7.7 1.3-3.5 3.4-.7 1.8-3.3 2.7-11.9.9-.8 6.5-4.9 1.5-2.8 5.6 2.9 4.1 3.1.4-1.4 3.1-7.9-1.5-8.7.1-5.4 4.3-2.1 3.1 2.8 5.7-.9 14.4 4.9 4.6-5.8-4.5-2.1 1.8-1.8 2-3.3 1.3-5.3-.6-4.4-3.4-4.6 6.9-1.3 3.1.6 1.3 1.6.9.4-.3.8-.7 1 1.3 1.4 1.2-.3 3.6 3.1 1.1 2.1.9-.5.9.4.4 2.6 1.3.6 1.7.5 1.7 1.3-.1 1.3 2-.1 2.6 1.5.1 1.3.4 1 1.5.4h1.6l1.3-.3.6 1.2.7-.8 2.9 1.3.5-.4.7.8 1.6 1 .4-.7.8.6.1 1.1 1.7.8.5.1 1.7.8.3 1.4 1.4 1.1.1 1.4-.1 1.6.7 1.1 1.4-.8 1.1 1.1 1.3 3.1h1.1l.3 1.1.9.1.5 1.5 1.3.2.4 2.3-1.8.9-.4 2.8.5 1.6.1 4.3 1.4 2.2-.3 2.7-.8-.1.6 1.1-1 2.1 1.6 1.3.4-.7 2.4 1 .5-.7 1.1 1.1-.4 1.4.1 1.8.8.3-.6 2.2-1.9.8-.3 1.8.6 1.1-.3 1.3 2 2.7.3 2.1 1.6 1.8.9.2.3 1.2 1 .5.3 1.6 1.8 2.1.7 1.4-.3 1.2-1-.3-.1 1.2.4 3.3-.3 1.4.3 2.8-.9 1.3.1 1.3-1.3.5v1.3l-1.1.8v1.1l1.1 1.5-.6 3.6 2.3 5 2.3.7 1.3.1-.1 1.4.6.6v1.1l1.6 2.4.7 2.4 2.6 6.1-5.1 1.1-1.6-1.1-1.2-.1-.2 1.1-1.1.5-1.9-.8-.8 1.7-2.6-.8-1.1-.4-.7 1.2-.7 3.3-1.8-1.5-3.2-1.2-1.2-2.9-1.5-.9-.5.6.8 3.4 1.8 1.9.1 1.4-1.3-.5-1.7-1.9-1.9.1-.1-1.4-1.5-2.1-1.6.9-.4 2.7.3 2.9.4 2.3.5 2.1 1.1 1.8-.8.4-2.1-.6-.9.5.1 1.7-1.9.1-2.8.3 2.3 2.3-1.1 2-1.9.8-2.8-.1-2.5 1-.7 1.2 4 2.6-.3 1.2-1.4 1.2.9 3.9-1.1 2.9-3.4-1.8-.5-1.6-9.4-1-15.4-6.3-3.4 7.6-.9 1-3.1 1.9-1.4-1.5-1.5-.9-.1-.9.6-.9-3.5-2.4-.8.2-.1-1-1.7-.6-1.6-.8-.6-1-1-.4-.3-1-.8-.4H416l-1.2-1.3-1.6-.9-2.3-.5-1.1-.9zm3.7-4.4l-.9-1.1.3-1.8-1.3-.8-2.1.1-4.4-5.4.8-2.3-.8-2.6 2.4-.5.6-.9-1-1.2-1.5.8-1.6-1.6-1-2.4-2.6-1.4-1.9-2.1-2.1-2-1.8-2.2-3.8-1.9-.4 1.1 4.3 2.6 2.3 2.9.3 1.9 2.6 1.2 2.1 2.3 1.9 1.9-1.4.6-1.9 1.1 1.8 2.6.2 1.4-.6 1.5.4 2.6 1.4-.1.8-2.4 2.6 3.8 1.8 5.1 1.6-.4 1.1.6 3.9 1.3.1-1.1z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/vasterbotten/">
            <text transform="translate(25 151.713)">Västerbottens län</text>
          </Link>
          <Link to="/regioner/vasterbotten/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M440.8 226.613l2.7-3.6h1.6l.2-2 1.9.3 3.1-.2.3-1.3h1.6l.3-3 1.4-1.9 2.7-.6 1.2-2.3 1.2-3.3 1.3-4.6.5-3.9 2-2.7 2.3-3.2 3.5-3 2-3.8-.2-1.5-1.4.3-.9-3.3-1.7-1.7-2-.3-1.2-2.1.8-1.1-.1-3.5-3.3-.2-1.1-2.3 2 .4 2.2-3-.8-2.1 2.1-.9 2.1-4.7-3.5-1.9-.5-1.5-9.3-1-15.5-6.3-3.4 7.6-.9 1-3.1 1.9-1.4-1.5-1.5-1-.1-.9.6-.9-3.5-2.4-.8.2-.1-1-1.7-.7-1.6-.8-.5-1-1-.4-.4-1-.8-.4h-2l-1.2-1.3-1.6-.9-2.2-.5-1.2-.8-.9-1.9-1.8-.5-4.8-1.5-2.3-.8-15.1-15.3-3.3-.1-12.6-9.9-5.8-2.3.2 2.6-7.4 5.6-1 .1-7.3.4 1.5 13-1.7 4.9-1 9.9-.1 5.9-2.2 2.2-.9 5.2 4.9 4.5 1 .3.7 1.2 1.3 1.4-.2 1.6 1.4 1.6 1.4.2 1.4 2 .3 2.3 3.2 1.6 1.7 2.8-1.2.8 1.3.8.4 1.2 1.1-.4v1.1l2.1 1.8.5 3 1.2.1-.2-3.1 1.3-.8.8 2.5.2 2.5 4.8 3.3.1 3 3-.4 9.4 10.5 2.2 2.4 7.5 1.3 8.1 1.4 12-5.2 1.7 1.6-.8 1.7 1.3 3.1 2.6.3 2.2.5.9 1.1 1.8-.3 1.2 1.3 4.3 6.4v1.7l2 3.4 2 .5 1.6-.7-1.2-2.6.8-1.2 2.2 2 1.7 3.2 1.5-1.2-.7-2.1z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/jamtland/">
            <text transform="translate(59 235.713)">Jämtlands län</text>
          </Link>
          <Link to="/regioner/jamtland/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M381.3 258.213l-1.4 1.9-.6 2.8-2.1-.6-2.4 1-3-.8-6.9 3.4-6.4.9-2.1 1.5-1.2-1.3-3.1-.4-2.3.4.1 2.4.6 3.1h-1.1l.5 2.1 1.2.3 1.4 3.4 4 2.4 2.2-1.6.9.8.2 2.7 1.2.8.3 3.1-6.4 4.9.5 1.8-.2 2.3v1.9l-1.2-.9-2.8-.3-.4 2.1-1.4-2.6-1.4.8-.7-1.3-3.3 4.9-.6 6.6-1.8 1.8-1.1-1.1-3-.9-4.3-.2-1.8-.7-5.4-1-.9.6-1.1-1.6.2-1.8-1.8-3.8-3.8-4.6 3.2-3-.9-.3-.5-1.8-2.6 1.3-2.3-2.5-1.8-2.6-2.6-3.6-3.4.2-5.9-1.9-3.9-14.8 1.8-5.4-.6-6.2 2.4-3.7-3.7-11.4 4.8-8-.9-4.8 2.7-2.9.6-2.2 1.3-1.5 5.8-8.7 4-3 5.6-1.6 1.8.4 7.6 1.8 4.6 1.6 3.8-7.6-.3-8.4-.1-2.6-.8-.9-2.9-1-4.3-3.3 10.1-19.1 2.1-2.8 4.9 4.4.9.4.8 1.1 1.3 1.4-.1 1.6 1.4 1.7 1.4.1 1.4 2 .3 2.4 3.3 1.6 1.7 2.8-1.2.8 1.3.8.4 1.2 1.1-.4.1 1.1 2.1 1.8.5 3.1 1.2.1-.2-3.1 1.3-.8.8 2.5.2 2.5 4.8 3.3.1 3 3.1-.4 9.4 10.5-2.4 5.4-.2 2.9.8 4.3-4.4 1.9-1.3-.7-.9.9-2.8-1.4-2 1.8-2-1.3-1.4.6 3.5 4.4-.3 2 .2 2.8 1.3-.5 1.5.8-.2 2.5 8.9 7.9 7.8 9.3-6.6 1zm-34.9-16.4l-2.1-1.3-1.3.4-1.9-1.6-2.5-1-3-1 2.5 4.9-1.9.1 1.4 1.4 2.2.8 1.8 1.4.4 1.9.9 3.3-.1 2.9-1.3.3 1.1 3.1 1.2.7.9-3.1-.6-4.4-.5-2.9-.3-2.4 1.4-.5 1.1-.6-.9-.5-1.3-1 .3-1.1z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/vasternorrland/">
            <text transform="translate(644.5 239.713)">Västernorrlands län</text>
          </Link>
          <Link to="/regioner/vasternorrland/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M377.1 281.513l5.2.1 5.4 1.4 2.2 1.3 1.2-.3 2.3.6 1-.5 1.8.9 1.7-.4 3 .9.7-2.1 1.7-.4.5-1.9-2.8-.8-1.6-2.4.4-1.6 1.4-.5-.4-3.2-2-.7v-1.1l1.6-.7 1.4 2.9 2.8.6-.3-1.9 1.3-1.2 1.8 1 1.1-3.2 2.8-2.3-1.6-1.5 1.3-1 1.9-3.2-2.5.2-.3-1.4 2.4.4 2.5-2.7-1.1-1.1.9-.9 2.2 1.7 1.9-3.4.9-2.8-3.1-.4.4-1.3 1.5-.1.2-1.9 1.8-3.8 2.1.1 3.9-2.8 1.5 1.1 1.5-1.8v-3.4l2.1-.6.6-5.8-2-3.4v-1.7l-4.3-6.4-1.2-1.3-1.8.3-.9-1.1-2.2-.5-2.6-.3-1.3-3.1.8-1.7-1.7-1.6-12 5.2-8.1-1.4-7.5-1.3-2.2-2.4-2.4 5.4-.1 3 .7 4.2-4.4 2-1.2-.7-1 .9-2.8-1.4-2 1.8-2-1.3-1.4.7 3.5 4.4-.3 2 .2 2.8 1.3-.5 1.5.8-.2 2.5 8.9 7.9 7.7 9.2-6.5 1-3.5 4.6-1.4 1.9-.5 2.8-2.1-.6-2.4 1-3.1-.8-6.9 3.5-6.5.8-2.1 1.5-1.2-1.2-3-.4-2.3.4v2.5l.6 3h-1l.5 2.2 1.2.3 1.4 3.4 4 2.4 2.2-1.6.9.8 3-2.6 2.7-.2 7.6 3.5.8.8z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/dalarna/">
            <text transform="translate(70 314.713)">Dalarnas län</text>
          </Link>
          <Link to="/regioner/dalarna/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M331.1 362.313l.3 3.2-2.3-3.3-3-6.2-2.5-.3-1.4-1.1-1.1-3.3-2.4-4.6-.8-2.6h-1.1l-.5-2.8-8.9-10.3-.4-2.1.6-3.9 1.7-1.3 1-2.4.9-4.6-5.1-9-2.9.1-4.9-6.8 3.9-21.8 5.9 1.9 3.4-.2 2.6 3.6 1.8 2.6 2.3 2.5 2.6-1.3.5 1.8.9.3-3.2 3 3.8 4.6 1.8 3.8-.2 1.8 1.1 1.6.9-.6 5.4 1 1.8.7 4.3.2 3 .9 1.1 1.1 1.8-1.8 3 1.3.5 2.2-.8 1.9 2-.4 1 .5 2.3-.2 3 .6 1.8-4.6 1.3 3.8 8.3 11.8.6 3.8 1.5 2.9 3.5 2 4.1.4 2 5 3.3 3.7-.6 1.9-1.8 1.2.4 1.4-1.6 2.5-1.9.6 1.8 3.4.9.3.5 1.2 2.1 4.2 2.4.6 1.2 1 .2 1.5.8.4.3 2.3 1.7 1.5-3.1.2-1.1.5v1.3l-1.9 1.3-.9 1.6-3.8.4-.8-.4.3-1.6-1.3-.8-1.1-.1-.7-1.7-1.1-.3-1.5 1.3-2.4-.6-.4 1.3-.8.6.1 1.4-1.2 2.1 1 1.3-.7 3-1.4-.6-1.6-.1-1 2.3-1.7 1.8-1.6-2.8-2.2-2.6-1.9-1.4-1.2-1.8-.9.2-.5-.8-1.4.9-1.4-1.1-.1-1.5-1.1.1-1.6 1 .6 3.8-6.3-1-4.5-3.1-.5-3.2-.9-2.8-2.1.2-.4-1.2h-1.4v-.2zm15.1-22.7l1.3 2 3.4-1.8 1.1 3 .4-3.2 1.5-.6 1.3-1.4-1.6-1.1-1.1 1-1.6.9-3.1-3.3h-1.2l-1.6-2.4-1 1 .3 1.5 1.4.2 1 1.1-.9.5h-1.6z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/gavleborg/">
            <text transform="translate(644.5 303.713)">Gävleborgs län</text>
          </Link>
          <Link to="/regioner/gavleborg/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M380.8 341.513l-.6 1.9-1.4 1.1.4 1.4-1.6 2.5-1.9.6 1.7 3.4.9.3.5 1.2 2.1 4.2 2.4.6 1.2 1 .2 1.5.8.4.3 2.3 1.6 1.5 1.6-.1 1.7-1.7-.4-.8.8-1 4 .7 2-1.7v-4.9l1.9-1.8.8-7.5-2.7-1.5 2.5-2.3-2.2-2.2.7-2.1-2.3-4 1.1-2-1.5-1.3.2-1-.6-5.9 1.4-1.4.6-2.6-2.4-2.8-.3-2 1.4-2.5-1.4-3 1.2-2.2.9-2.2.9-2 2 .9.7 1.5 1.2.4.6-3.5-1.8-.8-.7-1.1.1-2.4-1.4-1.5.8-3.6 1.3-2.5.8-5.5-3-.9-1.7.4-1.8-.9-1 .5-2.3-.6-1.2.3-2.2-1.3-5.4-1.4-5.2-.1-3.4.1-.8-.8-7.6-3.5-2.7.2-3 2.6.2 2.7 1.2.8.3 3-6.4 4.9.5 1.8-.1 2.3v1.9l-1.2-1-2.8-.2-.5 2.1-1.4-2.6-1.4.8-.7-1.3-3.2 4.9-.7 6.6 3 1.2.5 2.2-.7 1.9 2-.4 1 .5 2.2-.2 3 .6 1.9-4.6 1.3 3.8 8.2 11.8.6 3.9 1.5 2.8 3.5 2 4.1.5 2 5z"
            />
          </Link>
        </g>{' '}
        <g className={s.county}>
          <Link to="/regioner/varmland/">
            <text transform="translate(56 361.713)">Värmlands län</text>
          </Link>
          <Link to="/regioner/varmland/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M312.2 403.213l1.1-1.1.1-3 .6.9.8.9 1.3-.1-.5-1.3.6-.9 2.1-.3 1.1 1.5 1.3 2.9 1.6-1.5.6-1.9 1.9-.8 1 1.7 1.5-1.2 1.5 1.2 1.2.8h1.8l.6 3.8-1.4 2.7-1.2 2.5-.1 2.2.7.3.9-1.6 1.6-1.1 1 .9-.6 1.8h1.9l1.2 1.7 1.4-3.9-1-2.5.4-1-.3-2 .9-3.3v-.5l1.2-3 1.9-2-1.3-2.8.4-1.1.9.4v-2.4l-.7-3.3.4-1.4-1.1-2.1 1.1-.7-.4-2.3.4-3.2-1.2-.5-.6-1.4 2.5-.9-.5-1.9-4.5-3.1-.5-3.2-.9-2.8-2 .2-.4-1.2h-1.4l.3 3.2-2.3-3.4-3-6.1-2.5-.3-1.4-1.1-1.1-3.3-2.5-4.6-.8-2.6h-1.1l-.5-2.8-8.9-10.3-.5-2-1.2.3-2.6-.3-5.1 1.1 1.9 5.2-.2 1.8.9 4.4 2.2 3.9-.1 2 1.7 3.4-.1 4.4-2.4 3.5.6 5.8-.9 2.1-1.4 3.8-1.4.9-.7 1.9-2.7 1.2-1.4 1.4-2.1.3-1.7-.7-2.3 2.2 1.2 2.5.1 2.5-1.3 1.4-.7 1.4-2.3.5-1.2 2 .8 4.1.5 4.3.7 1.7-.2 4.5 2.7-1 2.7 2.8-.3-3 3.5.1.6 2.9 1.7.8 1.6-.4.7 2.2 2.3.6 1.5-2.5 1.5.8 1.1 1.1v3.4l2.7-1 .1 1.7 1.8-.3.6 1.6 1.1.1.5 4 2.2 1.3 1-.8-.5-6.3-1.1-4.2z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/orebro/">
            <text transform="translate(85 399.713)">Örebro län</text>
          </Link>
          <Link to="/regioner/orebro/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M364.1 397.113l1.3 3-.5 1.3-1.4-.3-2.7.9-2.9-.1v1.1l3 1.2 2.8-1 1.7 2.1-.8 1.3 1 1.6 2.5.3v1.2l-2 .3-1 1.8-.5 1.8.6.9-2.2 2.3.8 1.4-1 1.4h-1.7l-.5 1.9-.7-1.2-1 .5-1.9-1.2-1.3 1.6h-1.1l-1 1.3-.8 1.6-.5 1.5-1.9 1.2.9-1.9-.2-1.4-.7.2v-2.1l-1.3.9-1.3 2.8-2 1.3-.8-1.8h-1.2l-.7 1.6-1.1.3-.1-1.1h-1.5l-.2-3-1.1-.1-1.7-1.5 1-1.4-1.3-1-.7-4.4 1.4-3.9-1-2.5.4-1-.3-2 .9-3.3v-.5l1.2-3 1.9-2-1.3-2.8.4-1.1.9.4v-2.4l-.7-3.3.4-1.4-1.1-2.1 1.1-.7-.4-2.3.4-3.2-1.2-.5-.6-1.4 2.5-.9-.5-1.9 6.3 1-.5-3.8 1.5-1 1.2-.1.1 1.5 1.4 1.1 1.5-.9.5.8.9-.2 1.2 1.8 1.9 1.4 2.1 2.6 1.6 2.7.1 1.9 1.5.8 1.1 3.6-.9 2.1.9 1.1 1.4-.1.2 1.7v2.7l2-.1-.7 1.4.7.6v2.3z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/uppsala/">
            <text transform="translate(644.5 339.713)">Uppsala län</text>
          </Link>
          <Link to="/regioner/uppsala/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M399.8 346.613l-.8 7.4-1.9 1.8.1 4.9-2 1.7-4-.7-.8 1 .4.9-1.7 1.7-1.6.1.3 3.3-.8.3.6 2.8-.6 1.3 2.1 1.7.2 1.9-.4.9 1.2 1.6h-.1l-.6 1.7-1.1 1.6 1.1 2 1.6 2.3.8 4.4 1.4 1.4 1.4-.9 1.3-.4 2.4 1.1 2.6 2.2 1.8.1-.1-2.1-1.5-3.1.2-.4.7-.3.1.6.3.6.6.9.7.9.8.5.4-.1.3-.4.3-.6.3-.1.1-.6-.8-.8-.1-.7.3-.7.4-.3.3-.1.3-.5-.2-.3.6-.6.6-.3-.1-.8.6.1h.6l.3.4.5.1.1.5.4.1.3-.6.5-.3h.4l.3.2.4-.2-.1-.3 1.6-.6.4-.1.3-.2.7-.6h.4l.6-.4.2.1.4-.1h.4l.9-3.3 3.3-.9 1.5-1.6.4-5.2.8-.4-1.3-1.6 1.6-.6.4-2 .4-2-.1-2.3h1.3l.6-1.1-.8-1.6-1.7-1.4 1.7-.2.3-1.3-1.4-.5-1.5-2.4-.8-3.6-.7.4-.1 1.8.9 3.5-1.4 1.3-2-.5-3.6-3.1-2.2-2.9-.2-2.5-1.7-1.1-2.3 1.1-1.1 1.9-1.6.3-1.1-2.9.1-2.2z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/vastmanland/">
            <text transform="translate(644.5 383.713)">Västmanlands län</text>
          </Link>
          <Link to="/regioner/vastmanland/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M387.4 365.413l-3.1.2-1.1.5v1.3l-1.9 1.3-.9 1.6-3.8.4-.8-.4.3-1.6-1.3-.8-1.1-.1-.7-1.7-1.1-.3-1.5 1.3-2.4-.6-.4 1.3-.8.6.1 1.4-1.2 2.1 1 1.3-.7 3-1.4-.6-1.6-.1-1 2.3-1.7 1.8.1 1.9 1.5.8 1.1 3.6-.9 2.1.9 1.1 1.4-.1.2 1.7.1 2.7 2-.1-.8 1.4.7.6v2.3l-2.6-.2 1.3 3.1-.5 1.3 3-.3.8 1.4 1.2-.6 1.5-1.8 1.5-1.3 1.1.4 1.8.3 2.6-.6.3-1-1-.8.1-1.1-3 .3-.6-1.8 2.4.1 1.4-.8 1.8.8 2.5-.6.8-1.1 1.3-1.4-.7-1.2 1.4-.8 1.5 1.1 1.3 1.6 1.6-.7.6-1 1.8.2-.8-4.4-1.6-2.3-1.1-2 1.1-1.6.6-1.7h.1l-1.2-1.6.4-.9-.2-1.9-2.1-1.7.6-1.3-.6-2.8.8-.3-.4-3.2z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/stockholm/">
            <text transform="translate(464.5 400.713)">Stockholms län</text>
          </Link>
          <Link to="/regioner/stockholm/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M410.346 410.013l-.2-.5v-.5l-.7.6-.1.2.2.8-.1.5-.6.2h-.3l-.1-.7v-.5l.2-.8-.2-1.1-.1-.2-.2-.5-.1-.3-.2-.2-.2.3.1.3.4.6.1.7v.4l-.2.2h-.4l-.1.2.1.2-.5.4-.2.2v.3l.3.3.1.2-.4.7.1 1.6.1.5.2-.1.3-.8.1-.5.1-.7.3-.3.3.3.1.5.1 2 .1 1.2-.2.8-.2.2-.4-.2-.4-.1-.4 1.6-.4-1.8-1.6-.7-.1-1h-3.4l-1.6-2.3.3-3.7-1.2-2-.3-2.1.9-1.1.4.7.6-.3h.6l.5.3.7.3v-.3l-.8-1.2-.1-.3v-1l-.1-.3-.1-.3.4-.1.1.3h.2l.5.4h.3l.6.7 1.6.9h.5l.3.4.2.8.4.8.2.4.3.1.1-.3-.3-.8-.2-.9v-.2l-.2-.2-.1-.2.1-.4.4-.2.2.2.5-.1v-.2l.6.1.5.3.2.4.4.4.4-.3.5.1h.5l.8-.1.4.3.2.4.1.3.2-.3-.1-1.1-.1-.3.1-.4.4-.3.4-.3.4-.2.4-.2h.5l.2-.2.5-.1.5-.2h.5l.3-.2-.3-.2.5-.1.4.4.3.1.3-.2v-.3l-.3-.4-.6-.4-.8-1 .6-.6.1-.5v-.6l.1-.2.3-.3-.1-.1.6-.6.2-.1.2.4v.2h.3l.5-.3.1.1v.7l-.1.1-.5-.2-.1.3v.9l.4.1h.3l.3.2 1.2-.1.4-.1.2-.3-.2-.2-.4.1-.1-.2.3-.1.1-.2-.4-.4-.1-.2h-.7v-.2l.1-.3h.3l.4.2.4-.2.2-.1.1-.4-.1-.2-.2-.1-.3-.1.2-.2h.2l.2.1.2.2.3-.2h.2l.1.3.4-.1.3.1.3-.1.4-.7v-.2l.1-.2.4-.1.3-.3.3-.5.2-.1.8-.9.4-.1.1-.2.7-.5.6-.5.5-.2.7-.6 1.1-1.9.3-2.2 2.3-1.3 3.3.2 1.2-.8-.2-1.8-2.1-.6-.1-1.8h1.5l.7-2.2-1.3-1.1-2-1.4-1.5-2.7-1-3.6-.8-.5.3-2.7-1.7-1.6-.2 2.1-.6 1.3-1.3-.4-2.1-.4-.4 2-.4 2-1.6.5 1.3 1.7-.8.3-.4 5.2-1.5 1.6-3.3.9-.9 3.2h-.4l-.5.1-.2-.1-.5.4h-.5l-.7.7-.3.2h-.4l-1.6.6.1.4-.4.1-.2-.1h-.5l-.5.2-.2.6h-.4l-.1-.5-.5-.2-.3-.3h-.6l-.6-.2.1.9-.6.2-.6.6.2.2-.3.5-.3.1-.3.3-.3.7.1.7.8.8-.1.5v.3l.2.2-.3.7-.3.2-.3.3-.1.3.1.2.8.9.2-.1-.1-.3.1-.2h.2l.2.2v.8l.1.3h.4l.1-.3-.2-.2-.1-.3.3-.3h.4l.5.3.4.3.1.4.1.2.1.7.4.1.2.1v.2l.3.1.2-.4v-.8l.1-.7h.3l.2.6.3-.3.2.3-.1.2v.1l-.1.2-.4 1.2v.6l.1.3.2.3.2.3.7.7.6.6.8.4.2.4.2.2.4.1.3.3h.3l.3-.1.2-.4v-.7l.2.1.3.4.4.2h.4l.4-.1v.4l.3.1.5.1h.3l.5-.1.7-.3.5-.3h.1v.5l.1.7.1.2h1.2l.3.1.2.4.2.3h.5l.3.2v.2l-.2.1h-.4l-.7-.2h-.4l-.1.1.1.1.2.2.5.1 1.1.7.3.5.3.1.4.1.4.6-.2.3-.5.3-.1.4.3.4.7.2.3-.1.3-.1.2.1-.5 1-.3.2-.2.2h-.2l-.1-.2h-.2l-.5.5h-.5l-.3.1-.6.3-.3.6.9-.1.1.3-.3.3-1 .3-.5.4-.3.3-.3.1-.1-.2v-.2l.4-.4.2-.1v-.2l-.1-.2.1-.2.3-.1.1-.1.2-.2v-.2l-.2-.2-.5.1-.3.2-.1.3.1.2v.2l-.4.3-.9.4-.2.2-.5.2-.2.3-.1.3-.3.2h-.5l-.3.1-.1.4-.1.4-.1.2-.3-.1v-.4h-.3v.2l.1 1 .1.4-.1.2h-.1l-.2-.4-.1-.2-.1.5-.1.3-.4 1 .3 1.4-.3.9-.4.4-.5.5-.2 1-.4.3-.5 2-1.3.5v-.5l.3-.5.3-.4.1-.6-.5-1.1-.5-1-.5-.5-.2-.4.2-.3v-1.5l-.3-.3.1-.4.2-.4-.3-1.2-.2-.7v-.3l.2-.5.3-.4-.2-.5.2-.5z"
            />
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.3"
              d="M422.146 398.913l.7-.1.5.2.7.6v.3l-.4.2.2.1v.2l-.4.6-.1.3.2.3.6-.1.5.1.5.3.2.2.7.4h.1l.2-.2-.3-.3v-.2l1.5-.2 1.4-.5.1.2-1 1.3.1.2-.4.1-.4.1-.2.3-.5.2v.4l-.3.2-.3.2-.2.2-1-.2-.2-.6-.5-.1-.5-.3-.2-.6-.4-.2-.4-.6h-.7l-.3-.2.2-.2.2-.2-.2-.5.1-.2.3-.3.2-.2-.3-.1h-.3l-.3-.1-.5-.1-.1.7-.1.3-.3.2-.4.3-.5-.1-.3-.1v-1.5l.5-.3.2-.1.1-.3.9-.1.3.1.5-.1z"
            />
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.3"
              d="M424.146 397.313l.2.3v.4l-.2.3v.5l.2.2.1.2v.4l-.2 1v.4l.3.1h.3l.7.5.4-.1 1.1-.2.5-.2.2-.3.2-.5v-.3l-.2-.4-.5-.3-.6-.2-.5.2-.1-.3.5-.1.4-.1.2.1.2-.1.3-.2v-.2l-.2-.3h-.3l-.3.3-1.5-.9-.3-1-.1-.1-.4-.1h-.3l-.2.2-.2-.1-.2.1v.2l.2.2.2.1zm-14 3.3l.2.4-.2.3-.5.2-.5-.2-.3-.5-.2-.2h-.3l-.4-.6-.6-.9-.3-.8-.2-.7-.5-1.1-.2-.5v-.3l.3-.2.3.4.3.2.5.5.3.2.2-.2.5.2.4.5h-.3l-.3.2v.2l.3.6h.2l.2-.1-.1-.2.1-.2.6.7v.1l.3.4.1.6v.9z"
            />
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.2"
              d="M406.546 399.213l.1.3-.1.3.3.2v1.1l.2.2.3.2.8.5.9.6h1l.2.2.6.2.5-.3.1-.1-.1-.3-.7-.3.1-.2h-.2l-.6.2-.3-.1-.5-.2-.7-.4-.4-.4-.6-.1-.4-1.5-1-2.8h-.2l-.4.1-.3.2-.3.3v.4l.2.4v.2l.3.2h.2l.1-.1.4.9.2.2z"
            />
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.3"
              d="M426.546 394.813h.3l.1-.2v-.6l-.2-.5.1-.3.2-.1h.3l.3-.2.2-.4.3-.5.2-.4h.3v-.2l-.2-.1-.1-.5h-.2l-.1-.1.3-.2-.3-.2-.3.3-.2.2-.9.5-.1.4-.4.3-.1.2.1.3-.3.2.1.1h.3l.1.2v.3l-.3.3-.2-.1-.1-.3-.2-.1-.3.2-.1.3.2.2v.5l.1.3.2.3.2.2v.8l.3-.1.3-.3v-.5zm-2.9 18.3l.2-.3.2-1.5.5-.6v-.5l.5-.5.1-.4-.4-.8v.1l-1.1 1.2-.8.4-.2.2.2.1v.1l-.5.8v.2l.3-.1.1.1-.1.2-.2.2-.2.2.1.5.4.3.5-.2.1.3zm10.7-26.3l-1.2-.5-1.2.7-.9 1.7-1.1.9.4.4 1.7-1.4 1 .2.1-1 1.2-.2zm-14.5 30.3l.3-.1.2-.2.2-.2.5.1.6-.4-.2-.2-.3-.2.2-.3 1-.6.2-.3v-.4l-.1-.2-.3.2-.2.3-.7.5-.4-.1-1.2.8-.3.2-.5.4-.5.4v.4l.2-.1.3-.1.3-.4.2.2v.3zm-3.2-2.1l.2-.2.2-.4.2-.1.2.1.1.3.1.2.4-.1.3-.2-.3-.5v-.3l.1-.2.3.1.1-.2v-.3l.1-.4h.4l.3-.2v-.1h-.2l-.7-.2-.6.3h-.7l-.1.1-.2.3v.6l-.5.5v.6l-.1.3.1.1zm13-16.6l.2.4.1.5v.5l-.1.4-.3.3-.6.3-.2.1-.2-.1.1-.7v-.5l-.1-.5-.7-1 .7-.3.3.4.3-.2zm-25.7.3l.2.3-.1.4.2.4.4.3.2.1.2-.2-.1-.5.1-.3.1-.2-.1-.4-.2-.1-.3-.9-.2-.3-.1-.3h-.3l-.4.1v1.2zm12.9-.9l.1-.1.3.1.4.2.6.2.6.1h.8v.3h-.4l-.1.2v.1l.2.2-.2.2-.2.2-.4.1h-.4l-.5-.1-.3-.5-.1-.2v-.3l-.2-.2-.2-.1-.1-.2z"
            />
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.2"
              d="M412.346 400.313v.2l-.1.1-.1.2v.4l-.3.3h-.3l-.4-.5-.5-.7v-.2l.1-.4.1-.2h.5l.3.1.3.5.2.2zm20-3.8v-.3l-.1-.3v-.3l.1-.3.3-.3.4-.2h.6v.2l.1.3-.2.2-.2.1v.4l-.3.4-.4.2-.1.2v.2l-.4.3-.1-.1v-.3zm-2.2 5l.5-.5h.4l.4.3-.4.5-.2.6-.3.2-.3-.1-.3.1h-.3v-.4l.2-.5zm3.9-4.5l.1.6-.1.3-.4-.1-.1-.2v-.7l-.1-.3.3-.1.1-.4.2-.1h.3l.1.3zm-5 7.9l.1-.3.2-.3.2.2v.4l.5-.3.3.1-.2.4-.2.1-.4.1-.4.2-.3.2-.3.3v-.3zm4.5-6.4v.3l-.2.2v.2l-.3.5.1.3.2.3-.2.2-.6-.1.1-.3v-.5l.1-.5.1-.3.3-.3h.4zm-12.5-2.6l-.2.4.3.2.4-.4.5-.1v-.2l-.4-.2-.2-.2-.2.1-.2.1z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/sodermanland/">
            <text transform="translate(644.5 421.713)">Södermanlands län</text>
          </Link>
          <Link to="/regioner/sodermanland/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="m372.1 416.013 2 1 .9 1.8 1.4 1.6 1.4.3 .5.9 2.5 4.8 3.8.1 3 1.1 1.3 1.9 1.5.1 1.8.2 2.3-.8-.1-.9-1.7-.5.9-.5 1.3.2 1.2.8 1-1.4-1.1-1-1.5-1.4 1.4-.5 1 1h1.1l2.2.5 .9-1 1.3.3 .4-1.9.5 .1.4 .2 1.1-.2-.5-.7.3-2.5 1.3 1.1.7-.5-.5-1.1 1.1-1.1-.4-1.8-1.7-.7-.1-1h-3.3l-1.6-2.3.2-3.7-1.1-2-.3-2.1.9-1.1-.6-1.5 1.1-.8-.2-1.3-.7-.2 1.1-1.3-.9-2.1-2.8-.6-.6.8 .7 2.5-1.5.2-.8-2.7.6-1.5-1.3-.8-.9.5-.3 1.4-2.4-1.1-1.1.5-1.7.2-2 .6-1.9-.3-2 .3-3.9.4-.1 1.1 1 .8-.3 1-2.6.6-1.8-.3-1.1-.4-1.5 1.3-1.5 1.7 3 .2 1.5 1.2 4-1.3.8 .1-.7 1.3-1.7.7-2.3.2-1.5.6-2.3.8-.1 1.5-1.1 1-1.3-.1v1.2l-2 .3-1 1.8-.5 1.8.6 .9 2.2.9 1.2-2.4 1 .6.4 1z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/vastra-gotaland/">
            <text transform="translate(0 445.713)">Västra Götalands län</text>
          </Link>
          <Link to="/regioner/vastra-gotaland/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M291.546 469.613l-1.8 1.1-1.5.5-2.2.4-.5-.6h-1.5l.2-1 .1-1.7-.2-.4-.4.6h-.2l-.7-1.9v-.3l.2-.3 1.6-.9h-.5l-.6.2-.3-.2-1 .2-.4-.7-.3-.1-.3.1-.1.5-.3.2h-.3l-.4-.2-.3-.6-.1-.2v-.4l.4-.6.8-.3.8-.3.3-1.2h-1.1l-.3-.2-.1-.8-.1-.4-.5-.4-.3-.4.2-.5.5-.7.2-.5.3-.8.7-1.3-.3-.5.1-.5.1-.4 1.1-1.2.3-1 .1-.9-.1-.9-.1-.9.4-.5.5-.6.4-.7.1-1-.1-1 .4-.1.5-.6.1-.7h-.7v-.9l-.4-.8-.6-1.2.2-.5.8-1h-1.3l-.9-.3-.9.1.4.5-.2.4h-.8l-.5.9-.6.6-.6.3-.6.2-.4.8-.6.6-.7.4-1.1.2h-.9l-.2-.3.6-.9.4-.5.6-.1.6-.4.5-.6.4-.5v-1.2l-.5.4-.6.8-.5.5-.9.1v-.3l.3-.4.2-.7-.5-.1-.4-.3.3-.7.2-.9-.7.2.1-1.3-.7.6-.5-.2-.2-.4h-.3l-.2.4-.8.5h-.7l-.1-.5.6-.7-.1-.4v-1.3l.1-.6h.4l.1.5.4.1.4-.3.1-.5-.1-.5v-.7l-.9-3.9.8-1.3-.8-3.6-1.5-2.8.3-3.5-.2-1-.6-2.2v-.6l.1-.1.5.2.3-.1v-.4l-.6-.8-.1-.5.1-1.9 1.8-3 .9-.1.6-.4.8-.5.9.4 1.8 3.9-.5 3.8.1 1.1 1.1.7 3.2-1.3.6-1.7v-1.4l.9-2 1.6-2.4-.5-.8.4-3.4 1.3-1 2.7-1 2.8 2.8-.3-3 3.5.1.6 2.9 1.6.8 1.6-.4.8 2.2 2.3.6 1.4-2.5 1.5.8 1.2 1.1v3.4l-2 3.3-.8 1.2-.4 3.2-1.9 2.7-1.5 2.4v2.4l1 1.1 2.2.2.4.7-1.1 1-1.3 1.5-1 1.8-1.3 1.7-1.8 1-1.3 1.8-.1 1.2 2 .4.8-.6 1.2.3 1.9-2.8 1.2.2-.5 2.5 1.6-.7-.1-.9 1.6-1.9 2.6-.4 1.4-2.1-.1-.7 1.4-1.5 2.4-3.6 1.5.3.8.8-.8 2.5-1.3 3.8.8.7 1.7.3 1-.8.4-1.8.7-2.1 1.9-1.3 2.1-.6 1.8-1.2h1.9l1.5-.3 2-1.7.6-1-.8-.5-1.5.6-1 .6-.2-1.5-1.2-1.2.4-1.4 3.7.7 1 .8 1.3-1.3.8-1.8.5-2.3-.3-2 2.4-1.5h1.9l1.2 1.7.8 4.4 1.3 1-1 1.4 1.6 1.5 1.1.1.2 3h1.5l.2 1.1 1-.3.7-1.6h1.3l.7 1.8-1.1 1.4-1.8.8-1 .9v1.8l-.2 1.6-1 2.4-.8.5-1.2 2.6-1.1 2.4-1.5 1.8-.7 3-.8 1.7-.2 1.6-2.1-.3-.1 3.2-.9 1.1-.1.7-2.4.7-.1-1-1.6-.7-.7.5-1-.7-.5.2-.5 1.4-1.1 1.3v1.8l.8 2.3-.2 1.6-.1 3.3-.7 1.1-.2 1.1.7 1.6-.4 1.2-1 .5-.1.8.1 1.9-.3 1.1-1.1.7-2.6 4-.5 1.5-1.3.6v1l-1 .2-.4.8-1.7.4-.6 2.2-1-.4-.6.9-.5 2-1.1 1.4-.7-.5-.6.4-.6-.3.3-.9-1-.3-1.6.3-.1-2.2.5-.3-.5-1.2-1.6-.1-1.3-.9-1.9-1.9-1.2-.2-2.8.5-.6 1.6-1.7.3.1-2-.7-.9.5-2.8-.3-1.4-.3-.3-.5-.3-.2-.5.2-.9-.2-.8-.3-.7.4-1.6z"
            />
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.3"
              d="M283.146 448.113l.2-.7.2-1.1-.1-.8.2-.7.2-.7-.1-.5-.4-.6-.4-.3-.4-.3-.2-.8.1-.7-.8-.1h-.5l-.7.5-.1.5v.7l-.1.4h-.3l-.5-.1-.5.1-.5.6-.4.5-.6.3-.4.3-.7.2-.3.3-.5.3-.5-.1-.5-.2-.7.9-.5 1 .3-.2.4-.5.5.1v.5l.4.4.5.6.2.6-.1.5-.3.5-.2.1.3.4.4-.4.3.4.3.1.4-.1.5-.5.4-.5.1-.7.3-.5.8-.4.5.3.6.4.3.4-.1.5.5.1.5-.6.4-.2.2-.1.6-.1z"
            />
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.3"
              d="M279.646 453.713v.3l-.3.1-.5.2-.3.3-.2.4-.2.4-.7.1-.1-.4v-.8l-.4-.2-.1-.1-.2-.3v-1l.3-.1h.6l.1-.3-.1-.3h-1.2l-.2-.4v-.4l.2-.6.3-.1.4-.2 1.1.3.5-.1.2-.3.5-1.1.2-.1h.4l.4.4v.4l-.3.4.4.2.6-.4.4.5.1.6-.1 1-.2.7-.4.3-.2-.1-.1-.4-.5-.1-.2.7zm-.8 9.1l.4-.2.3.7-.3.5-.3.8v.7l-.1.5-.3.2-1-.9v-.4l.5.1.1-.4-.2-.2v-.4l.4.1v-.8zm0-6.2l1 .2-.4.8-1.6.8-.7-.5.9-1.1zm-1.9 6.5l.4.2.9-1.2-.7-1z"
            />
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.2"
              d="M281.646 449.613h.3l.2-.4v-.4l-.3-.2-.1.5zm-.6-.2l.4-.7.1.8z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/ostergotland/">
            <text transform="translate(464.5 445.713)">Östergötlands län</text>
          </Link>
          <Link to="/regioner/ostergotland/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M349.9 450.013l1.1.6.9 3.5.5 1.3-.8.9-.7 1.7.5 1.6 1.5 1.9-.3 1 .8 2.8.9 2 3.1-.2 2.9.6.3-1.9.6-.8 1.3.2.4-1.4 1.2-1.2-.2-1.1 2-.5 2.3.8.4 1.3 1.5-.8 1.2.8 2.1-2 1.1-.1-1.1-3.6 1-.8-1.7-2.6.3-2.1 2-.1.6 1.1 1.2-.2-.5-1.7.6-.6 1.5-1.4 1 1 1.7-.7 2.1 2.7.7-1.4 1.3.7 1.1 4.5 1.7.3 1.3-1-.9-1.8 1.4-.8-1.8-1.8-.3-1.3 1.9.9 1.1-2.7-1.2-1.8-1.8-1.3 3.6-.8.7-1.9-1.6-1.3-2.1-.1-.5-1.4-2-.6-.7-1.1 1 .2 2.3.3 2.4-.8 1.5-2.5-1.7-1.7-2.5-1.9-3-1.4-3.2-.2-.4 1.8-1.2-1.3-1.7.7-.7-.4v-1.3l.9-.8 2.1.3h1.5l2.9.7 2.2.4 1.4.1-1.3-1.9-3-1.1-3.8-.1-2.5-4.8-.5-.9-1.4-.3-1.4-1.6-.9-1.8-2-1-2.1-1.4-.4-1-1-.6-1.2 2.4-2.2-.9-2.2 2.3.8 1.4-1 1.4h-1.7l-.5 1.9-.7-1.2-1 .5-1.9-1.2-1.3 1.6h-1.1l-1 1.3-.8 1.6-.5 1.5-1.9 1.2-.3 2.7-1.5 1.7 1.5 1.2 1.3.3.7.7-1.3.8-.9 2-1.3.6-.9-1-.9.5-.1 1.3-2.5 2-.3 1.4-.5 1.4.3.8-.6.9-.5 2.7-1.2 4.1 1.4.6 3.1-.5.2 1.3 3-.7z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/jonkoping/">
            <text transform="translate(49 478.713)">Jönköpings län</text>
          </Link>
          <Link to="/regioner/jonkoping/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M350.9 458.013l.7-1.7.8-.9-.5-1.3-.9-3.5-1.1-.6-.8 1.6-3 .7-.2-1.3-3.1.5-1.4-.6-1.6 2.4-.4 1.8-2.1 1.4-1.5 2.6-.5 2-.2 2.4h-1.2l-.6.6-.6-.5.2-1.6-.3-1.7-.6-.6.1-2.9 1-1.7.8-2.7.5-3.3-2.1-.3-.1 3.2-.9 1.1-.2.7-2.3.7-.2-1-1.6-.7-.6.5-1.1-.7-.5.2-.4 1.4-1.1 1.3v1.8l.8 2.3-.3 1.6v3.3l-.8 1.1-.1 1.1.6 1.6-.4 1.2-1 .5-.1.8.2 1.9-.4 1.1-1 .7-2.7 4-.5 1.5-1.2.6-.1 1-1 .2-.4.8-1.6.4-.6 2.2-1-.4-.7.9-.4 2-1.2 1.4-1 .9v1.3l.8 2.6 2.1-1.8.2-1.2.9.5 2-.8 2.2.4.7-.5.1 1.3.7-.2 1.8 1.2-.4 1.5.6 1.3 1.4.6.5-2.7 1-.6 1.6.2.9 2.3 1.3-.6.3-1 2-.6 1.2.4.8 1 .5-.4 1.3 2.1.2 1.8.8 2.1 1 .6 1.1-.7 1.3-2.8-1.4-1.7-.2-1.5.5-.6.1-3.8h1l2.2-.1 1.3-.3.2-1.3.9.2.4-.6 1.4-.1 1.2-.8h1.4l1.3.8 1 1 .3 2 1.3-.1.4-1 .9-.3.9-.5.4-.7 1.6.1-1-1.4h1.4l1 .7 3.5-.5 3.4 1.3-.7-1.8-.7-.5-.1-2.2 1-.7-.4-1.8.3-.8v-2.2l1-.8 1.2.8.1-1.8.7-.7-.3-1.1-1-.9 1.7-2.1-3.1-2.4-1.6-.3-.5-1.1-2.9-.6-3.1.2-.9-2-.8-2.8.3-1-1.5-1.9z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/halland/">
            <text transform="translate(71 505.713)">Hallands län</text>
          </Link>
          <Link to="/regioner/halland/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M312.6 501.613l.5 3v3.3l1 1.3.5 2 .3 1.2.6.6.6 2.3-.6 1.7.5.8-.4.9-.8.7-1-.1-1.7 1-1.3 1.3-1.1 1.1-1.1-1-3.6-.6-1-.2.6-2.3-1.5-.9.8-1.1.4-1.2.1-1.9-.2-1.9-.6-2.1-1.3-.8-1.3.8h-1.2l-.9-2-.8-1.7-.7-2.2.1-2-1.2-1.1-1.7-1.4-1.7-.6-1.1-1.4.4-1.3v-1.1l-.6-1.4-1-.8-.7-1.6-.1-2.3-1-1.8-1.4-1.7.1-1.6 1.1-.6-.1-1.1-.2-1.4-.2-.4-.8.2-.3-.4.6-1.5v-1.9l-.2-.9-.4-.2-.4.4-.3.9-.6 2-.3.7-.4.2-.5-.3-.3-.7-.8-2v-.7l.2-.7.6-1.6-.1-1.1v-1.4h1.4l.6.6 2.2-.4 1.5-.5 1.8-1.1 1.2 1.6-.5 1.6.4.7.2.8-.3.9.2.5.6.3.3.3.2 1.4-.5 2.8.8.9-.1 2 1.7-.3.5-1.6 2.8-.5 1.2.2 2 1.9 1.3.9 1.6.1.4 1.2-.5.3.2 2.2 1.5-.3 1 .3-.2.9.5.3.7-.4.6.5-1 .9v1.3l.8 2.6 2.1-1.8.2-1.2.9.5 2-.8 2.2.4.7-.5.1 1.3.7-.2 1.8 1.2-.4 1.5.6 1.3 1.4.6.1 1-.8 2.4-.8-.3-.2.7H318l-1.1 1-.3-.5-2.3.6-.7-.5z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/kronoberg/">
            <text transform="translate(644.5 512.713)">Kronobergs län</text>
          </Link>
          <Link to="/regioner/kronoberg/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M352.4 488.613l-.9.5-.9.3-.4 1-1.3.1-.3-2-1-1-1.3-.8h-1.4l-1.2.8-1.4.1-.4.6-.9-.2-.2 1.3-1.3.3-2.2.1h-1l-.1 3.8-.5.6.2 1.5 1.4 1.7-1.3 2.8-1.1.7-1-.6-.8-2.1-.2-1.8-1.3-2.1-.5.4-.8-1-1.2-.4-2 .6-.3 1-1.3.6-.9-2.3-1.6-.2-1 .6-.5 2.7.1 1-.8 2.4-.8-.3-.2.7H318l-1.1 1-.3-.5-2.3.6-.7-.5-1 1 .5 3v3.3l1 1.3.5 2 .3 1.2.6.6.6 2.3-.6 1.7.5.8-.4.9.9.9 1.8.1 3-.7 1.9-.8 1.8.1 1.3-.8 2 .1 1-1.5.1-1.1h.9l.7 1 2.4.7.3-.4 3.7 1 2.4 1 1.6.2 1.7 2.1.9.5 2.1.4 1.7.8 1-.8 1-2.3 1.2-.9h2.4l.2.9h1.3l.3-1.1 1.1-.6 1 .8.9-1 .2-2.3.6-.7-.2-1.8 1.3-1.7-.2-1.1.2-1.7-1.3-2.6 1.8-.8 2.3-.3.2-1.3-.9-2.5.1-.8.9-.5 2.2.8.9-.2 2.6-.2.7-2.3-.9-1.9-1.4-1.9-1.6-.7-.9-1.8-2-.9.5-1.3-.6-.7-3.4-1.3-3.5.5-1-.7h-1.4l1 1.4-1.6-.1z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/kalmar/">
            <text transform="translate(463.5 490.713)">Kalmar län</text>
          </Link>
          <Link to="/regioner/kalmar/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M367.246 493.513l1.4 1.9 1 1.9-.8 2.3-2.5.2-1 .2-2.2-.8-.9.5-.1.8 1 2.5-.3 1.3-2.3.3-1.8.8 1.4 2.6-.3 1.7.3 1.1-1.3 1.7.2 1.8-.7.7-.2 2.3 1.5-.5 1.9.7.2-1.4 1.6.7.6 1.2h1.1l.4 1.1.4 1 1.3.4 1.4 2.7 1.3.9 2.2-.1.9.7 1.5-.7.7-3.3.8-2.7.9-1 .6-1.9.8-.3-.1-1.9.4-1.3 1-1.9 1.6-.4.9-4.1 1 .8.6-.9-.6-1-.7.5.6-3.7.5-2.2-.1-1.8.7-2.2 2-3-1.9-.9-.8-2.7.8-1.5-.4-2 1.7-1.3-.3-2.2 1.6-.1.8-2.2.7-2.4-.4-1.5-2-2.4 2-.2.7-.7v-1.3l-1.4.5-.8-1 .7-1.7 1.2-.6-.1-2.1-1.6-1.1-1.9-2.7 1.5-2.1 1.9.3 1.2 1.1.4-2.4-.3-3.4-1.3 1-1.7-.3-1.2-4.5-1.3-.7-.7 1.4-2.1-2.7-1.7.7-.9-1-1.6 1.4-.5.6.5 1.7-1.3.2-.5-1.1-2 .1-.4 2.1 1.8 2.6-1 .8 1.1 3.6-1.1.1-2.1 2-1.2-.8-1.6.8-.4-1.3-2.3-.8-1.9.5.2 1.1-1.2 1.2-.4 1.4-1.4-.2-.6.8-.2 1.9.5 1.1 1.5.3 3.2 2.4-1.7 2.1.9.9.3 1.1-.7.7v1.8l-1.2-.8-1.1.8.1 2.2-.3.8.3 1.8-1 .7.1 2.2.8.5.6 1.8.6.7-.4 1.3 2 .9.8 1.8zm17.6 12.4l-1.3 3.4-.5 2.2-1.1 2-.2 1.7.2 4.2.4.2v6.5l.3.7-.1 2.1 1.5-1.3.7-2.3 1.4-3.5-.3-1.4.9-2.3.7-2.5.2-1.9 1.2-1.2-.2-.9.4-2.2 1.6-6.1 1-.3.7-1.4-.1-1.3.5-.9v-2.8l1.3-1.1-.6-1.4h.9l.7-2.7 1.1-2.4.6-.6v-2.4l-.3-1 .6-1.4 1-.6-.4-1.6-.6.4-.5-.7-.9.8-1.1 1.8-.2 2-.3 1.3-.9.6.3 1.4-.5 2-1 2.2-.7 1.7-.9.9-.7 2-.6 2.5h-1.4l-.9.8-.7 2.4zm42.254-44.9l1.3-.4 1-.3.4-1.8 1-.8 1.1-.7 1.5 3.2.9-2.7.9-1 3.1.6 1.1-1 .4-1.6 1.6-1 1.8.6 1.2-.1.4.8-.5.7-1.7.1-1.3.5-.5.6.5 1-.9 1.7-1.3.9-.7.5.1 1.5h-1.4l-.1 2.6-1.7.1-1.1-.8-.2 2.2-.7 3 .8.4-.2 2.5-.7 1.3 1.1 1.9 1.3 1 1.4.3-.6 1.8-1.7.6-1.4.4-1.5 2.5.1 1.2.9.7-.8 1.4-2.5 1-.3.8-3.1 2.5.9.4-2.2 1.8.1 2.6 1.2.5-1.6 2.3-2.4 1.7-1.5-.1 1.2-2.9.2-1.7 1.4-.9.5-1.2-.2-1-1.4 1.1-.5-.2.3-2.4-1-.7-.7-.6v-3.2l-1.1-.4.2-1.6 1.1-1.3.3-2.6-.8-1.1-.5-2.1-.5-2 .3-1.6 1.7-2.2 1.2-.5 1.5-2.2 1.5-3 .7-2.6z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/gotland/">
            <text transform="translate(644.5 474.713)">Gotlands län</text>
          </Link>
          <Link to="/regioner/gotland/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M427.1 461.013l1.3-.4 1-.3.4-1.8 1-.8 1.1-.7 1.5 3.2.9-2.7.9-1 3.1.6 1.1-1 .4-1.6 1.6-1 1.8.6 1.2-.1.4.8-.5.7-1.7.1-1.3.5-.5.6.5 1-.9 1.7-1.3.9-.7.5.1 1.5h-1.4l-.1 2.6-1.7.1-1.1-.8-.2 2.2-.7 3 .8.4-.2 2.5-.7 1.3 1.1 1.9 1.3 1 1.4.3-.6 1.8-1.7.6-1.4.4-1.5 2.5.1 1.2.9.7-.8 1.4-2.5 1-.3.8-3.1 2.5.9.4-2.2 1.8.1 2.6 1.2.5-1.6 2.3-2.4 1.7-1.5-.1 1.2-2.9.2-1.7 1.4-.9.5-1.2-.2-1-1.4 1.1-.5-.2.3-2.4-1-.7-.7-.6v-3.2l-1.1-.4.2-1.6 1.1-1.3.3-2.6-.8-1.1-.5-2.1-.5-2 .3-1.6 1.7-2.2 1.2-.5 1.5-2.2 1.5-3 .7-2.6z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/blekinge/">
            <text transform="translate(464 555.713)">Blekinge län</text>
          </Link>
          <Link to="/regioner/blekinge/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M340.7 528.813l.4 4.7-.9.5-.2 1.1 1.4 1.2 1.2.7 1.5.1 1.3-1.5-1.4-1.5-.7-1.9-.2-1.7 1.3.3h.9l1.7-.2 2.3-.1h1.6l.9-1 .8.9 1.6.1 2-.4.9-.3.6 1.8 1.6-.9.5-1 1.1 1.1.9-.8 1.5-.6.7.6 2.3-.5 1.1 1.1-.4 1.2-1.4 1.3 1 .4 1.8-1 1.5 1.3 1.4-3 1-.7 1.2-2.5.9-3.6-1.5.7-.9-.7-2.2.1-1.2-.9-1.5-2.7-1.2-.4-.5-1-.3-1.1h-1.2l-.5-1.2-1.6-.7-.3 1.4-1.9-.7-1.4.5-.9 1-1-.8-1.1.6-.3 1.1h-1.3l-.2-.9H351l-1.2.9-1 2.3-1 .8-1.7-.8-2.1-.4-.9-.5-1.7-2.1-1.6-.2-1.3 2.2-1.3.4-.5 2.1.4 1.4.5 1.3.2 1.8 1.1.5 1.3-.2z"
            />
          </Link>
        </g>
        <g className={s.county}>
          <Link to="/regioner/skane/">
            <text transform="translate(92 544.713)">Skåne län</text>
          </Link>
          <Link to="/regioner/skane/" tabIndex="-1">
            <path
              fill="#ea8f12"
              stroke="#fff"
              strokeLinecap="square"
              strokeWidth="1.4"
              d="M321.3 519.013l1.9-.8 1.8.1 1.3-.8 2 .1 1-1.5.1-1.1h.9l.7 1 2.4.7.3-.4 3.7 1 2.4 1-1.3 2.2-1.3.4-.5 2.1.4 1.4.5 1.3.2 1.8 1.1.5 1.3-.2.5 1 .4 4.7-.9.5-.2 1.1-1.8.6-.9 1.7-1.7 1.1-.8 1.8-1 .5-1.7 3-.3 2.8.4 2.7 1.3 1 .4 2.3 1.2 1.2.3 1.8-.8 1.5-1.7 1.8-1.2 2.2-.4.8-2.1-.3-.9.1-2.4-1.8-1-.4-1.5.3-2.6-.2-.9.5h-1.2l-1.3 1.6-2.6-.1-.7.2-.8.7h-.9l-1.1.7-.4-.4h-.8l-.5-.2-1.2-.6-2.1-.6-.9.2h-.5l-1.1-.8-.8-.6-.7.1-.4.2-.1.3h-.4l-.3-.3-.4-.2-1.4.5 1.2-2.4.1.2.2.9.7.3.6.1.2-.5.4-.9.1-1-.2-.7-.3-.7-.5-1.1v-1.8l.4-.4 1.2-.8.7-.4.9-.3.3-.5-.1-.4v-.3l.4-.8-.1-.3-.2-.9-.4-.2-.8-.8-.6.1-.4-.2.3-.4-.3-.6-.7.3-.3-.6.3-.4.4-.3-.2-2-.5-1.6-1.5-.4-1.2-3.7-.4-2-.9-1.8-1.1-1.4-.9-1.4-.7-.9-.3-.7-.3-2.5-.4-1.3-.6-1.3-1-.8 1-.1 2.1 1.4 1.8 1.1.5.9h.7l.8.2.5.1.9-.5.5-1.3-.6-1.3-1.1-1.2-.5-1.4-1.1-1-1.2-.4-.2-1.6 1.2-.9 1.1-.5 1.5.7 1.1.8 1.3-.5 1.5.9-.6 2.3 1 .2 3.6.6 1.1 1 1.1-1.1 1.3-1.3 1.7-1 1 .1.8-.7.9.9 1.8.1z"
            />
          </Link>
        </g>
        <g className={s.strokeGroup}>
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M456 90.913h172.8"
            data-name="Line 350"
          />
          <path fill="#cfd4d8" d="M452.8 87.613h6.6v6.6h-6.6z" data-name="Rectangle 6697" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M406.7 235.813h222.1"
            data-name="Line 351"
          />
          <path fill="#cfd4d8" d="M403.6 232.513h6.6v6.6h-6.6z" data-name="Rectangle 6698" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M385.5 300.413h243.3"
            data-name="Line 352"
          />
          <path fill="#cfd4d8" d="M382.3 297.113h6.6v6.6h-6.6z" data-name="Rectangle 6699" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M379.2 375.913h249.6"
            data-name="Line 353"
          />
          <path fill="#cfd4d8" d="M376.1 372.613h6.6v6.6h-6.6z" data-name="Rectangle 6700" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M415.5 394.713h35.8"
            data-name="Line 354"
          />
          <path fill="#cfd4d8" d="M412.4 391.413h6.6v6.6h-6.6z" data-name="Rectangle 6701" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M395.5 417.213h233.3"
            data-name="Line 355"
          />
          <path fill="#cfd4d8" d="M392.3 413.913h6.6v6.6h-6.6z" data-name="Rectangle 6702" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M372.8 442.913h78.5"
            data-name="Line 356"
          />
          <path fill="#cfd4d8" d="M369.6 439.613h6.6v6.6h-6.6z" data-name="Rectangle 6703" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M430.1 471.913h198.7"
            data-name="Line 357"
          />
          <path fill="#cfd4d8" d="M426.9 468.613h6.6v6.6h-6.6z" data-name="Rectangle 6704" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M379.2 486.613h72.1"
            data-name="Line 358"
          />
          <path fill="#cfd4d8" d="M376.1 483.313h6.6v6.6h-6.6z" data-name="Rectangle 6705" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M352.8 508.413h276"
            data-name="Line 359"
          />
          <path fill="#cfd4d8" d="M349.6 505.113h6.6v6.6h-6.6z" data-name="Rectangle 6706" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M313.9 541.913H189.5"
            data-name="Line 360"
          />
          <path fill="#cfd4d8" d="M310.4 538.613h6.6v6.6h-6.6z" data-name="Rectangle 6707" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M305.3 500.813H189.5"
            data-name="Line 361"
          />
          <path fill="#cfd4d8" d="M301.8 497.513h6.6v6.6h-6.6z" data-name="Rectangle 6708" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M333.3 476.313H189.5"
            data-name="Line 362"
          />
          <path fill="#cfd4d8" d="M329.8 473.013h6.6v6.6h-6.6z" data-name="Rectangle 6709" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M294.7 442.913H189.5"
            data-name="Line 363"
          />
          <path fill="#cfd4d8" d="M291.2 439.613h6.6v6.6h-6.6z" data-name="Rectangle 6710" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M349.2 397.313H189.5"
            data-name="Line 364"
          />
          <path fill="#cfd4d8" d="M345.7 394.013h6.6v6.6h-6.6z" data-name="Rectangle 6711" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M309.5 360.413h-120"
            data-name="Line 365"
          />
          <path fill="#cfd4d8" d="M306 357.113h6.6v6.6H306z" data-name="Rectangle 6712" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M318.5 312.413h-129"
            data-name="Line 366"
          />
          <path fill="#cfd4d8" d="M315 309.113h6.6v6.6H315z" data-name="Rectangle 6713" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M324.2 235.813H189.5"
            data-name="Line 367"
          />
          <path fill="#cfd4d8" d="M320.7 232.513h6.6v6.6h-6.6z" data-name="Rectangle 6714" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M369.5 149.913h-180"
            data-name="Line 368"
          />
          <path fill="#cfd4d8" d="M366 146.613h6.6v6.6H366z" data-name="Rectangle 6715" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M410.7 360.613v-25.2h218.1"
            data-name="Path 156"
          />
          <path fill="#cfd4d8" d="M407.4 357.113h6.6v6.6h-6.6z" data-name="Rectangle 6716" />
          <path
            fill="none"
            stroke="#cfd4d8"
            strokeMiterlimit="10"
            d="M358.2 523.013v29.1h93.1"
            data-name="Path 157"
          />
          <path fill="#cfd4d8" d="M354.9 519.913h6.6v6.6h-6.6z" data-name="Rectangle 6717" />
        </g>
      </g>
    </svg>
  );
};

export default withStyles(s)(RegionOfficesWithNames);
